import axiosInstance from './axios';
import backendUrl from '../backendUrl';
import { token } from './auth';

const baseUrl = `${backendUrl}/api/herds`;

const setConfig = () => {
  return {
    headers: { 'x-auth-token': token },
  };
};

const getAllHerds = async (): Promise<any> => {
  const response = await axiosInstance.get(baseUrl);
  return response.data;
};

const getHerd = async (
  herdName: string,
  limit: number,
  page: number
): Promise<any> => {
  // Newest-first (the sort menu is gone); token so hidden posts stay hidden.
  const response = await axiosInstance.get(
    `${baseUrl}/name/${herdName}/?limit=${limit}&page=${page}`,
    setConfig()
  );
  return response.data;
};

/** Delete a herd. Refused by the server while it still has posts. */
const deleteHerd = async (id: string): Promise<any> => {
  const response = await axiosInstance.delete(`${baseUrl}/${id}`, setConfig());
  return response.data;
};

const createHerd = async (herdObj: any): Promise<any> => {
  const response = await axiosInstance.post(`${baseUrl}`, herdObj, setConfig());
  return response.data;
};

const joinHerd = async (id: string): Promise<any> => {
  const response = await axiosInstance.post(
    `${baseUrl}/${id}/join`,
    null,
    setConfig()
  );
  return response.data;
};

const updateDescription = async (id: string, descriptionObj: any): Promise<any> => {
  const response = await axiosInstance.patch(
    `${baseUrl}/${id}`,
    descriptionObj,
    setConfig()
  );
  return response.data;
};

const getHerdPreview = async (herdName: string): Promise<any> => {
  const response = await axiosInstance.get(
    `${baseUrl}/name/${encodeURIComponent(herdName)}/preview`
  );
  return response.data;
};

const getTopHerds = async (): Promise<any> => {
  const response = await axiosInstance.get(`${baseUrl}/top10`);
  return response.data;
};

const getMyHerds = async (): Promise<any> => {
  const response = await axiosInstance.get(`${backendUrl}/api/users/me/herds`, setConfig());
  return response.data;
};

const herdService = {
  getAllHerds,
  createHerd,
  deleteHerd,
  getHerd,
  getHerdPreview,
  joinHerd,
  updateDescription,
  getTopHerds,
  getMyHerds,
};

export default herdService;
